import styled from "styled-components"

export const Container = styled.div`
    padding: 8px 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const NavButton = styled.button`
    border: none;
    padding: 7px 14px;
    border-radius: 10px;
    cursor: pointer;
    margin-right: 4px;
    margin-left: 4px;
    background-color: var(--${props => props.color});
`